import { createSlice } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  selectedAcc: {
    id: 0,
    title: '',
    ixSubType1: 0,
    ixSubType2: 0,
    ixSubType3: 0,
    ixSubType4: 0,
    ixSubType5: 0,
    sSubType1: '',
    sSubType2: '',
    sSubType3: '',
    sSubType4: '',
    sSubType5: ''
  },
  selectedSub1: { id: 0, title: '' },
  selectedSub2: { id: 0, title: '' },
  selectedSub3: { id: 0, title: '' },
  selectedSub4: { id: 0, title: '' },
  selectedSub5: { id: 0, title: '' },
  data: null,
  dateRange: {
    dt1: null,
    dt2: null,
    textValue: ''
  },
  brch: {
    required: false,
    ixBrch: 0,
    label: ''
  },
  page: 0,
  limit: 25,
  loading: false,
  error: false,
  errorMsg: '',
  graphData: {},
  graphRequestData: {},
  showCompact: false,
  showOtherDetails: false
};

const slice = createSlice({
  name: 'sl',
  initialState: INITIAL_STATE,
  reducers: {
    setReportState(state, action) {
      return { ...state, ...action.payload, loading: false };
    },
    resetState(state) {
      return { ...INITIAL_STATE, brch: { ...state.brch, ixBrch: 0 } };
    },
    setDateFilter(state, action) {
      state.dateFilter = action.payload;
    },
    setDateRange(state, action) {
      state.dateRange = action.payload;
    },
    setAccount(state, action) {
      for (let i = 1; i <= 5; i++) {
        if (
          state.selectedAcc[`ixSubType${i}`] !== action.payload[`ixSubType${i}`]
        ) {
          state[`selectedSub${i}`].id = 0;
          state[`selectedSub${i}`].title = '';
        }
      }

      state.selectedAcc = action.payload;
    },
    setSub1(state, action) {
      state.selectedSub1 = action.payload;
    },
    setSub2(state, action) {
      state.selectedSub2 = action.payload;
    },
    setSub3(state, action) {
      state.selectedSub3 = action.payload;
    },
    setSub4(state, action) {
      state.selectedSub4 = action.payload;
    },
    setSub5(state, action) {
      state.selectedSub5 = action.payload;
    },
    setError(state, action) {
      return { ...state, ...action.payload };
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setPage(state, action) {
      state.page = action.payload;
    },
    setLimit(state, action) {
      state.limit = action.payload;
      state.page = 0;
    },
    setBrch(state, action) {
      state.brch = {
        ...state.brch,
        ixBrch: action.payload
      };
    },
    setBrchRequired(state, action) {
      state.brch = {
        ...state.brch,
        label: action.payload.label,
        required: action.payload.required
      };
    },
    cancelRequest(state) {
      state.loading = false;
    },
    setGraphData(state, action) {
      state.graphData = action.payload;
    },
    setRequestData(state, action) {
      state.graphRequestData = action.payload;
    },
    setShowCompact(state, action) {
      state.showCompact = action.payload;
    },
    setShowOtherDetails(state, action) {
      state.showOtherDetails = action.payload;
    },
    setParams(state, action) {
      state.selectedAcc.id = action.payload.ixAcc;
      state.selectedAcc.title = action.payload.sAccTitle;
      state.selectedAcc.ixSubType1 = action.payload.ixSubType1;
      state.selectedAcc.sSubType1 = action.payload.sSubType1;

      state.selectedSub1.id = action.payload.selectedSub1.id;
      state.selectedSub1.title = action.payload.selectedSub1.title;

      state.dateRange.dt1 = action.payload.dt1;
      state.dateRange.dt2 = action.payload.dt2;
      state.dateRange.textValue = action.payload.textValue;

      state.brch.ixBrch = action.payload.ixBrch;
    },
    clear() {
      return INITIAL_STATE;
    },
    restore(_, action) {
      return action.payload || INITIAL_STATE;
    }
  }
});

const slReducer = slice.reducer;

export const {
  setReportState,
  resetState,
  setDateFilter,
  setDateRange,
  setAccount,
  setSub1,
  setSub2,
  setSub3,
  setSub4,
  setSub5,
  setError,
  setLoading,
  setPage,
  setLimit,
  setBrch,
  setBrchRequired,
  cancelRequest,
  setGraphData,
  setRequestData,
  setShowCompact,
  setParams,
  restore,
  clear,
  setShowOtherDetails
} = slice.actions;
export default slReducer;
